module.exports = __webpack_public_path__ + "public/HelpPage/block1img.jpeg?d03a40ed";